import TPESearchRequest from "../common/TPESearchRequest";
import { TPESearchResult } from "../common/TPESearchResult"

export interface OpenCalculationReview {
    calculationNumber: string,
    recordId: string,
    workbookName: string,
    atpCalculationStatus: string,
    apttusCalculationStatus: string,
    taskStatus: string,
    dueDate: number,
    dueDateDisplay: string,
    owner: string,
    hasComments: boolean
}

export enum CalculationReviewApplyCommentType {
    CWB,
    Template,
    CLI
};

export interface CalculationComment {
    comment: string,
    commentedBy: string,
    commentedOn: number,
    commentedOnDisplay: string,
    applyCommentType: CalculationReviewApplyCommentType
}

export class OpenCalcReviewsSearchRequest extends TPESearchRequest {
    status?: string;
    userViewMode?: string;
}

export interface OpenCalculationReviewsResult extends TPESearchResult{
    items: OpenCalculationReview[]
}

export interface SaveOpenCalculationReviewNotificationCommentRequest {
    calculationNumber: string,
    comment: string,
    applyCommentToCWB: boolean,
    applyCommentToTemplate: boolean
}

export interface SaveOpenCalculationReviewNotificationCommentResponse extends SaveOpenCalculationReviewNotificationCommentRequest {
    commentsSaved: number
}